import EN from './strings_en';
import FR from './strings_fr';
import NL from './strings_nl';
import { createI18n } from 'vue-i18n';
import { PreferencesHelper, detectBrowserLanguage } from '@/helpers/PreferencesHelper';

const messages = {
    'en': EN,
    'fr': FR,
    'nl': NL
}
export const SUPPORTED_LOCALES = Object.keys(messages);

export function resolveLocale(preference) {
    return SUPPORTED_LOCALES.includes(preference) ? preference : detectBrowserLanguage();
}

export const i18n = createI18n({
    locale: resolveLocale(PreferencesHelper.load().language),
    fallbackLocale: 'en', // set fallback locale
    messages, // set locale messages
});

export function applyLocale(preference) {
    i18n.global.locale = resolveLocale(preference);
}